import { Dictionary, Static, String } from 'runtypes';

export { LoadTheUserInterfaceStatesForTheUserQuery } from './LoadTheUserInterfaceStatesForTheUserQuery';
export { UpdateTheUserInterfaceStatesForTheUserCommand } from './UpdateTheUserInterfaceStatesForTheUserCommand';

export const UserInterfaceStatesRunType = Dictionary(String, String);

export type UserInterfaceStates = Static<typeof UserInterfaceStatesRunType>;
